export type NotificationCounterSize = 'lg' | 'md' | 'sm' | 'xs';

export enum NotificationCounterVariant {
  Red = 'red',
  Neutral = 'neutral',
  Green = 'green',
  Blue = 'blue',
}
